import React, { useCallback, useEffect, useMemo, useState } from "react";
import NonlalinService from "../../../services/nonlalin/NonlalinService";
import UploadService from "../../../services/transaksi/UploadService";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import NonlalinDisposisi from "../../../utilities/nonlalin/NonlalinDisposisi";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { AsyncPaginate } from "react-select-async-paginate";
import SweetAlert from "react-bootstrap-sweetalert";
import { formatDateString, formatDateTimeLocalDateOnly } from "../../../utilities/Utils";

const ModalLhpScanning = ({ showAddLhpScan, handleCloseAddLhpScan, dataDisposisi, datappm, reloadList, isEdit }) => {

    let nonLalinService = useMemo(() => new NonlalinService(), [])
    let uploadService = useMemo(() => new UploadService(), [])

    const [dataLhp, setDataLhp] = useState(null)

    const [valueNoLhp, setValueNoLhp] = useState(null)
    const [valueTglLhp, setValueTglLhp] = useState(null)
    const [valueSppOpt, setValueSppOpt] = useState(null)
    const [filePath, setFilePath] = useState(null)
    const [fileNameOri, setFileNameOri] = useState(null)
    const [valueFile, setValueFile] = useState(null)

    const onChangeNoLhp = e => {
        setValueNoLhp(e.target.value)
    }

    const onChangeTglLhp = e => {
        setValueTglLhp(e.target.value)
    }

    const onChangeSppOpt = e => {
        setValueSppOpt(e)
    }

    const handleUploadFile = e => {
        e.preventDefault()
        // console.log(e)
        const file = e.target.files[0];
        // console.log(file)
        if (file) {
            if (file.type !== "application/pdf") {
                alert("Only PDF files are allowed.");
                return;
            }

            const newFileName = file.name.replaceAll(" ", "-").replace(".pdf", '_' + formatDateTimeLocalDateOnly(new Date()) + ".pdf")
            const renamedFile = new File([file], newFileName, {
                type: file.type
            })
            setFileNameOri(renamedFile.name)
            setValueFile(renamedFile)
            setFilePath(process.env.REACT_APP_API_URL_FILE + '/view/' + datappm.nomorAju + '/' + renamedFile.name)

        }
    }

    const fetchAllData = useCallback(async () => {
        if (!datappm.nomorAju || !dataDisposisi.noTugas) {
            return
        }
        try {
            const resLhpScan = await nonLalinService.getScanSampleHasil(datappm.nomorAju, '1', dataDisposisi.noTugas)
            setDataLhp(resLhpScan?.data)

            setValueNoLhp(resLhpScan?.data?.noLhp)
            setValueTglLhp(resLhpScan?.data?.tglLhp)
            setFilePath(resLhpScan?.data?.filePath)
            setFileNameOri(resLhpScan?.data?.fileNameOri)

            const resSppScan = await nonLalinService.getScanSampleTugas(datappm.nomorAju, '1', resLhpScan?.data?.noTugas)
            setValueSppOpt(resSppScan.data)
        } catch (error) {

        }
    }, [nonLalinService, datappm, dataDisposisi])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    async function loadOptionSpp(search, loadedOption, { page = 1 }) {
        const response = await nonLalinService.listScanSampleTugas(datappm?.nomorAju, '1', page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const [base64String, setBase64String] = useState(null)
    const [showOpenPreview, setShowOpenPreview] = useState(false)
    const handleClickPreview = async (dokPath) => {
        setBase64String(dokPath)
        setShowOpenPreview(true)
    }
    const handleClosePreview = () => {
        setBase64String(null)
        setShowOpenPreview(false)
    }

    const [kelengkapan, setKelengkapan] = useState({})
    const checkKelengkapan = () => {
        const checkKelengkapan = {}

        if (!valueNoLhp) checkKelengkapan.noLhp = 'Nomor LHP Wajib Diisi'
        if (!valueTglLhp) checkKelengkapan.tglLhp = 'Tanggal LHP Wajib Diisi'
        if (!valueFile) checkKelengkapan.file = 'File Wajib Diunggah'

        setKelengkapan(checkKelengkapan)
        return Object.keys(checkKelengkapan).length === 0
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const handleShowConfirmSave = () => setShowConfirmSave(true)

    const [showSaveSuccess, setShowSaveSucces] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)

    const handleClickSimpan = async () => {
        if (checkKelengkapan()) {
            try {
                // let dataheader = JSON.parse(localStorage.getItem('dataHeaderStorage'))
                setLoadingSave(true)
                let jsonLhpScan = {
                    ...dataLhp,
                    nomorAju: datappm.nomorAju,
                    jenisLhp: '1',
                    noTugas: valueSppOpt.noTugas,
                    noLhp: valueNoLhp,
                    tglLhp: valueTglLhp,
                    filePath: filePath,
                    fileNameOri: fileNameOri,
                    createdDate: new Date(),
                    createdBy: localStorage.getItem('userId')
                }
                // console.log(jsonDataDokumen)
                const response = await nonLalinService.saveScanSampleHasil(jsonLhpScan)
                if (response.data.kode === '200') {
                    const resUpload = await uploadService.uploadFile(datappm.nomorAju, valueFile)
                    // console.log(resUpload)
                    if (resUpload.status === 200) {
                        setShowSaveSucces(true)
                        setShowConfirmSave(false)

                        let dataDispo = {
                            ...dataDisposisi,
                            noTugas: valueNoLhp,
                            tglTugas: valueTglLhp,
                            createdBy: localStorage.getItem('userId'),
                            createdAt: new Date()
                        }
                        await nonLalinService.saveNonlalinPenugasan(dataDispo)

                        let dataPpm = { ...datappm, status: '034' }
                        await nonLalinService.saveNonlalinHeader(dataPpm)

                        let jsonStatus = {
                            nomorAju: datappm.nomorAju,
                            kodeStatus: '034',
                            waktuStatus: new Date(),
                            createdBy: localStorage.getItem('username')
                        }
                        await nonLalinService.saveNonlalinStatus(jsonStatus)
                    }
                }
                setLoadingSave(false)
            } catch (error) {
                setShowConfirmSave(false)
                setShowSaveFailed(true)
                setLoadingSave(false)
                // console.log(error)
            }
        } else {
            setShowConfirmSave(false)
            setShowSaveFailed(true)
        }
    }

    const handleClickSaveSuccess = () => {
        setShowSaveSucces(false)
        reloadList(datappm.nomorAju)
        resetField()
        handleCloseAddLhpScan()
    }

    const handleClickSaveFailed = () => {
        resetField()
        setShowSaveFailed(false)
    }

    const handleClickBatal = () => {
        resetField()
        handleCloseAddLhpScan()
    }

    const resetField = () => {
        setValueNoLhp(null)
        setValueTglLhp(null)
        setValueSppOpt(null)
        setFilePath(null)
        setFileNameOri(null)
        setValueFile(null)
    }

    return (
        <>
            <Modal
                show={showAddLhpScan}
                onHide={handleCloseAddLhpScan}
                size="lg"
                centered
                backdrop='static'
            >
                <Modal.Header><h6><NonlalinDisposisi idDisposisi={dataDisposisi.idDisposisi} /></h6></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nomor Aju" className="form-control-sm" value={datappm?.nomorAju} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor ST</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionSpp}
                                            value={valueSppOpt}
                                            getOptionLabel={(option) => option.noTugas}
                                            getOptionValue={(option) => option.noTugas}
                                            additional={{
                                                page: 1
                                            }}
                                            onChange={onChangeSppOpt}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor LHP<span className="text-danger">*</span></Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="Nomor LH Scanning" className="form-control-sm" value={valueNoLhp} onChange={onChangeNoLhp} />
                                    </Col>
                                </Form.Group>
                            </Form>
                            {kelengkapan.noLhp && <div className='text-danger'>{kelengkapan.noLhp}</div>}
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal <span className="text-danger">*</span></Form.Label>
                                    <Col sm="3">
                                        <Form.Control type="date" className="form-control-sm" value={valueTglLhp ? formatDateString(valueTglLhp) : null} onChange={onChangeTglLhp} />
                                    </Col>
                                </Form.Group>
                            </Form>
                            {kelengkapan.tglLhp && <div className='text-danger'>{kelengkapan.tglLhp}</div>}
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Upload LH Scanning <span className="text-danger">*</span> (max 1 Mb)</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="file" className="form-control-sm" accept='application/pdf' onChange={e => handleUploadFile(e)} />
                                    </Col>
                                </Form.Group>
                            </Form>
                            {kelengkapan.file && <div className='text-danger'>{kelengkapan.file}</div>}
                        </div>
                    </div>
                    {dataLhp &&
                        <div className='row'>
                            <div className='col-12'>
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">
                                            <Button size="sm" variant="outline-info" onClick={() => handleClickPreview(filePath)}><FaMagnifyingGlass /> Preview File</Button>
                                        </Form.Label>
                                        <Col sm="8">
                                            <Form.Label column sm="11" className="control-label align-self-center mb-0" htmlFor="searchNib">{fileNameOri}</Form.Label>
                                        </Col>
                                    </Form.Group>
                                </Form>
                                {kelengkapan.file && <div className='text-danger'>{kelengkapan.file}</div>}
                            </div>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => handleShowConfirmSave()}>Simpan</Button>{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickBatal()}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            <PreviewPdf showOpenPreview={showOpenPreview} handleClosePreview={handleClosePreview} base64string={base64String} />
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Data LHP Scanning?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data LHP Berhasil"
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data LHP Gagal"
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const PreviewPdf = ({ showOpenPreview, handleClosePreview, base64string }) => {
    // const pdfUrl = 'data:application/pdf;base64,' + base64string

    return (
        <>
            <Modal show={showOpenPreview} onHide={handleClosePreview} size='xl'>
                <iframe
                    src={base64string}
                    title='Preview PDF'
                    width="100%"
                    height="800px"
                ></iframe>
            </Modal>
        </>
    )
}
export default ModalLhpScanning